module.exports = __webpack_public_path__ + "static/EmilyIsAway0-2677ced87e9ffeb2ec72963e78836b90.png";